/* INTEGY V498/V636 — lightweight collection/search geometry compatibility owner.
   V636 removes redundant post-load + 80/300/900/1800ms normalization passes.
   CSS owns responsive columns; this runtime now reacts only to real grid lifecycle changes. */
(function () {
  'use strict';
  if (window.IntegyV498GridOwner) return;
  window.IntegyV498GridOwner = { version: 'V498' };

  var root = document.documentElement;
  var scheduled = 0;
  var observer = null;
  var requiredClasses = [
    'integy-v498',
    'integy-v401-navigation-cards-performance',
    'integy-v410',
    'integy-v411',
    'integy-v426-search-owner-ready'
  ];

  function activate() {
    requiredClasses.forEach(function (name) { root.classList.add(name); });
  }

  function clearGeometry(node) {
    if (!node || !node.style) return;
    [
      'width', 'min-width', 'max-width', 'flex', 'flex-basis',
      'grid-column', 'transform', 'left', 'right'
    ].forEach(function (name) { node.style.removeProperty(name); });
  }

  function normalizeGrid(scope) {
    activate();
    var base = scope && scope.querySelectorAll ? scope : document;
    var grids = [];
    if (base.matches && base.matches('.productgrid--items')) grids.push(base);
    Array.prototype.push.apply(grids, base.querySelectorAll ? base.querySelectorAll('.productgrid--outer:not(.productgrid-listview) .productgrid--items') : []);

    grids.forEach(function (grid) {
      grid.classList.add('integy-v498-grid-owned');
      clearGeometry(grid);
      Array.prototype.forEach.call(grid.children || [], function (item) {
        if (!item.classList || !item.classList.contains('productgrid--item')) return;
        var filteredOut = item.hidden || item.getAttribute('data-integy-v307-hidden-mismatch') === 'true';
        item.classList.toggle('integy-v498-filter-hidden', filteredOut);
        if (filteredOut) return;
        item.classList.add('integy-v498-card-owned');
        clearGeometry(item);
        Array.prototype.forEach.call(item.querySelectorAll('.productitem,.productitem__container,.productitem__image-container,.productitem--image,.productitem--info,.productitem--actions,.integy-v181-lite-actions'), clearGeometry);
      });
    });
  }

  function schedule(scope) {
    if (scheduled) window.cancelAnimationFrame(scheduled);
    scheduled = window.requestAnimationFrame(function () {
      scheduled = 0;
      normalizeGrid(scope || document);
    });
  }

  function relevantMutation(mutation) {
    if (!mutation || mutation.type !== 'childList' || !mutation.addedNodes) return false;
    for (var i = 0; i < mutation.addedNodes.length; i += 1) {
      var node = mutation.addedNodes[i];
      if (!node || node.nodeType !== 1) continue;
      if ((node.matches && node.matches('.productgrid--items,.productgrid--item,.productgrid--outer')) ||
          (node.querySelector && node.querySelector('.productgrid--items,.productgrid--item,.productgrid--outer'))) return true;
    }
    return false;
  }

  activate();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { schedule(document); }, { once: true });
  else schedule(document);

  window.addEventListener('pageshow', function () { schedule(document); });
  window.addEventListener('popstate', function () { schedule(document); });
  ['shopify:section:load','shopify:section:reorder','integy:filters:updated','facets:updated','productgrid:updated'].forEach(function (name) {
    document.addEventListener(name, function (event) { schedule(event && event.target ? event.target : document); });
  });

  if (window.MutationObserver) {
    observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        if (relevantMutation(mutations[i])) { schedule(document); break; }
      }
    });
    var startObserver = function () {
      if (document.body) observer.observe(document.body, { childList: true, subtree: true });
    };
    if (document.body) startObserver();
    else document.addEventListener('DOMContentLoaded', startObserver, { once: true });
  }

})();
